import { render, staticRenderFns } from "./advisor-comment.vue?vue&type=template&id=43c6b056&scoped=true"
import script from "./advisor-comment.vue?vue&type=script&lang=js"
export * from "./advisor-comment.vue?vue&type=script&lang=js"
import style0 from "./advisor-comment.vue?vue&type=style&index=0&id=43c6b056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c6b056",
  null
  
)

export default component.exports